import template from './ko-field-input-interval.html';

class IntervalInputComponentVM
{
	constructor(params)
	{
		this.params = params;

		this.readonly = ko.observable(params.readonly || false);
		this.name = ko.observable(params.name);
		this.label = ko.observable(params.label);
		this.$input = params.$input;
		this.help_text = ko.observable(params.help_text);
	}
}

export default {
	name: 'ko-field-input-interval',
	viewModel: IntervalInputComponentVM,
	module_type: 'ko',
	template: template
} 